var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_vm._v(" Az oldal nem található ")])
}
var staticRenderFns = []

export { render, staticRenderFns }